// src/reducers/sourcePaymentReducer.js

import {
    CREATE_SOURCE_PAYMENT,
    UPDATE_SOURCE_PAYMENT,
    DELETE_SOURCE_PAYMENT,
    GET_SOURCE_PAYMENTS_ALL,
    GET_SOURCE_PAYMENT_BY_ID,
    UPDATE_SOURCE_PAYMENT_STATUS,
    GET_SOURCE_PAYMENTS_ACTIVES,
    GET_PAYMENTS_TYPES,
} from '../actions/sourcePaymentsActions';

const initialState = {
    page: 1,
    sourcePaymentsList: [],
    sourcePaymentsActiveList: [],
    paymentsTypes: [],
    sourcePayment: {},
    loading: false
};

const sourcePaymentsReducer = (state = initialState, action) => {
    switch (action.type) {
         case  GET_PAYMENTS_TYPES:
            return {
                ...state,
                paymentsTypes:  action.payload,
            };
        case CREATE_SOURCE_PAYMENT:
            return {
                ...state,
                sourcePaymentsList: [...state.sourcePaymentsList, action.payload],
            };
        case UPDATE_SOURCE_PAYMENT:
            return {
                ...state,
                sourcePaymentsList: state.sourcePaymentsList.map((payment) =>
                    payment.uuid === action.payload.uuid ? action.payload : payment
                ),
            };
        case UPDATE_SOURCE_PAYMENT_STATUS:
            return {
                ...state,
                sourcePaymentsList: state.sourcePaymentsList.map((payment) =>
                    payment.uuid === action.payload.uuid ? action.payload : payment
                ),
            };
        case DELETE_SOURCE_PAYMENT:
            return {
                ...state,
                sourcePaymentsList: state.sourcePaymentsList.filter(
                    (payment) => payment.uuid !== action.payload
                ),
            };
        case GET_SOURCE_PAYMENTS_ALL:
            return {
                ...state,
                sourcePaymentsList: action.payload,
            };
        case GET_SOURCE_PAYMENTS_ACTIVES:
            return {
                ...state,
                sourcePaymentsActiveList: action.payload,
            };

        case GET_SOURCE_PAYMENT_BY_ID:
            return {
                ...state,
                sourcePayment: action.payload,
            };
        default:
            return state;
    }
};

export default sourcePaymentsReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/sourcePaymentsReducer.js